import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { TableData } from '@framework/ui/components/table/TableData.tsx';
import { Space, type TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import { PaymentBurdenTypeTags } from '../burden/payments/PaymentBurdenTypeTags.tsx';
import { paymentsColumns } from '../burden/payments/paymentsColumns.tsx';
import { DeletePaymentButton } from './buttons/DeletePaymentButton.tsx';
import { DownloadPaymentAlertButton } from './buttons/DownloadPaymentAlertButton.tsx';
import { DownloadPaymentReceiptButton } from './buttons/DownloadPaymentReceiptButton.tsx';
import { StartPaymentButton } from './buttons/StartPaymentButton.tsx';
import { StartStampDutyPaymentButton } from './buttons/StartStampDutyPayment.tsx';

interface PaymentsTableProps {
  payments: PagamentoWithDettaglioDTO[];
  readonly?: boolean;
  submission: RichiestaDTO;
}

export function PaymentsTable(props: PaymentsTableProps) {
  const { payments, readonly = false, submission } = props;
  const { t } = useTranslation();

  return (
    <TableData
      size="small"
      pagination={false}
      dataSource={payments}
      columns={
        [
          ...paymentsColumns,
          {
            title: t('payment-table.tipi', 'Tipo'),
            key: 'payment_burder_type',
            render: (_, record) => <PaymentBurdenTypeTags payment={record} />,
          },
          {
            title: t('payment-table.azioni', 'Azioni'),
            key: 'actions',
            align: 'right',
            hidden: readonly,
            render: (_, record) => (
              <Space>
                <DeletePaymentButton payment={record} />
                <DownloadPaymentAlertButton payment={record} />
                <DownloadPaymentReceiptButton payment={record} />
                <StartPaymentButton payment={record} />
                <StartStampDutyPaymentButton
                  payment={record}
                  submission={submission}
                />
              </Space>
            ),
          },
        ] satisfies TableColumnsType<PagamentoWithDettaglioDTO>
      }
    />
  );
}
